import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiEndpoints } from "../../helpers/constants";
import Axios, { authHeaders2 } from "../../helpers/axios";
import { handleTokenRefresh } from "./userSlice";

export const reqToUploadMediaFile = createAsyncThunk(
  apiEndpoints.media,
  async ({ data, onSuccess, onFailure }) => {
    const request = {
      method: "POST",
      url: process.env.REACT_APP_MEDIA_URL + apiEndpoints.media,
      data,
      headers: authHeaders2(),
    };
    try {
      const response = await Axios(request);
      if ([401, 403].includes(response?.data?.statusCode)) {
        const response = await handleTokenRefresh(request);
        onSuccess && onSuccess(response.data);
        return response;
      } else {
        onSuccess && onSuccess(response.data);
        return response;
      }
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response.data);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

export const reqToGetAddressFromLatLong = createAsyncThunk(
  apiEndpoints.getLocation,
  async ({ data, onSuccess, onFailure }) => {
    const request = {
      method: "POST",
      url: apiEndpoints.getLocation,
      data,
      headers: authHeaders2(),
    };
    try {
      const response = await Axios(request);
      onSuccess && onSuccess(response);
      return response;
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response.data);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

export const reqToGetTakedDetailsList = createAsyncThunk(
  apiEndpoints.getTakeDetails,
  async ({ data, onSuccess, onFailure }) => {
    const request = {
      method: "GET",
      url: apiEndpoints.getTakeDetails,
      headers: authHeaders2(),
    };
    try {
      const response = await Axios(request);
      onSuccess && onSuccess(response);
      return response;
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response.data);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

export const reqToAddTakedDetails = createAsyncThunk(
  apiEndpoints.addTakeDetails,
  async ({ data, onSuccess, onFailure }) => {
    const request = {
      method: "POST",
      url: apiEndpoints.addTakeDetails,
      data,
      headers: authHeaders2(),
    };
    try {
      const response = await Axios(request);
      onSuccess && onSuccess(response);
      return response;
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

const initialState = {
  loader: false,
  error: "",
  apiMessage: "",
  commonMessage: "",
  syncLoader: false,
  fetchLoader: false,
  scriptLoader: false,
  logoutLoader: false,
  initialSyncLoader: false,
};

const offlineSlice = createSlice({
  name: "offline",
  initialState,
  reducers: {
    reqToResetApiMessage: (state, action) => {
      state.apiMessage = action.payload;
    },
    reqToUpdateApiMessage: (state, action) => {
      state.commonMessage = action.payload;
    },
    reqToFetchDataProcess: (state, action) => {
      state.fetchLoader = action.payload;
    },
    reqToStartSyncProcess: (state, action) => {
      state.syncLoader = action.payload;
    },
    reqToInitialSyncProcess: (state, action) => {
      state.initialSyncLoader = action.payload;
    },
    reqToAutoScriptProcess: (state, action) => {
      state.scriptLoader = action.payload;
    },
    reqToUserLogoutProcess: (state, action) => {
      state.logoutLoader = action.payload;
    },
  },
  extraReducers: (builder) => {
    // UPLOAD MEDIA FILES
    builder
      .addCase(reqToUploadMediaFile.pending, () => {})
      .addCase(reqToUploadMediaFile.fulfilled, () => {})
      .addCase(reqToUploadMediaFile.rejected, () => {});

    // GET LOCATION
    builder
      .addCase(reqToGetAddressFromLatLong.pending, () => {})
      .addCase(reqToGetAddressFromLatLong.fulfilled, () => {})
      .addCase(reqToGetAddressFromLatLong.rejected, () => {});

    // GET TAKED DETAILS
    builder
      .addCase(reqToGetTakedDetailsList.pending, () => {})
      .addCase(reqToGetTakedDetailsList.fulfilled, () => {})
      .addCase(reqToGetTakedDetailsList.rejected, () => {});

    // ADD TAKED DETAILS
    builder
      .addCase(reqToAddTakedDetails.pending, () => {})
      .addCase(reqToAddTakedDetails.fulfilled, () => {})
      .addCase(reqToAddTakedDetails.rejected, () => {});
  },
});

export const {
  reqToResetApiMessage,
  reqToUpdateApiMessage,
  reqToFetchDataProcess,
  reqToStartSyncProcess,
  reqToAutoScriptProcess,
  reqToUserLogoutProcess,
  reqToInitialSyncProcess,
} = offlineSlice.actions;
export default offlineSlice.reducer;
